import React, { Component } from "react";
import { Helmet } from 'react-helmet'

class PageHelmet extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle}</title>
                    <meta name="description" content="Batisseur de coeur - Réalisation de projets de maconnerie traditionnelle en loire atlantique secteur nantes sud / clissons." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
